import PremiumBioPromotePopup from '../../premium_bio_promote_popup';
import CouponValidator from '../../webapp/coupon_validator';

document.addEventListener('DOMContentLoaded', () => {
  new PremiumBioPromotePopup();
  new CouponValidator();
})
